import axios from "axios";

const addToCartAction = (cartItem) => {
    return {
        type: 'add-to-cart',
        item: cartItem
    }
}

const removeFromCartAction = (item_id) => {
    return {
        type: 'remove-from-cart',
        item_id,
    }
}

const updateQuantityCartAction = (item_id, quantity) => {
    return {
        type: 'update-item-quantity',
        quantity,
        item_id: item_id
    }
}

export const removeFromCart = (item_id) => {
    return (dispatch, getState) => {
        return dispatch(removeFromCartAction(item_id))
    }

}


export const addToCart = (cartItem) => {
    return (dispatch, getState) => {
        return dispatch(addToCartAction(cartItem))
    }
}

export const updateQuantity = (item_id, quantity) => {
    return (dispatch, getState) => {
        return dispatch(updateQuantityCartAction(item_id, quantity))
    }
}

function getStorefrontClient(settings, client_token = null){
    const {storefront_access_token, aff_public_storefront_token, website} = settings;
    return axios.create({
        baseURL:`https://${website}/api/2022-10/`,
        headers:{
            'X-Shopify-Storefront-Access-Token': client_token || storefront_access_token || aff_public_storefront_token
        }
    })
}

export const searchForProducts = (keyword, cursor, client_token = null)=>{
    return (dispatch, getState)=>{
        const client = getStorefrontClient(getState().settings, client_token)
        const query = `{
          products (sortKey:CREATED_AT reverse:true first:20 ${keyword ? `query: "${keyword}"`:''} ${cursor ? `after: "${cursor}"`:''}) {
                edges{
                  node{      
                    id
                    totalInventory
                    availableForSale
                    priceRange{
                      maxVariantPrice{
                        amount
                      }
                      minVariantPrice{
                        amount
                      }
                    }
                    createdAt
                    title
                    handle
                    images (first:10){
                        edges{
                            node{
                                url
                            }
                        }
                    }
                   descriptionHtml
                    variants(first:100){
                      edges{
                        node{
                          id
                          title
                          image{
                            url
                          }
                          compareAtPrice{
                           amount
                           currencyCode
                          }
                          price{
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                  cursor    
                }
                pageInfo{
                  hasNextPage
                  hasPreviousPage
                }
              }
            }`
        return client.post('graphql.json', {
            query,
        }).then(({data})=> {
            const {products} = data.data;
            const cursor = products.edges.length > 0 ? products.edges[products.edges.length-1].cursor : null;
            const hasNext = products.pageInfo.hasNextPage;
            const p = products.edges.map(({node}) => {
                return {
                    platform_product_id: node.id,
                    title: node.title,
                    availableForSale: node.availableForSale,
                    product_url: `https://${getState().settings.website}/products/${node.handle}`,
                    images: node.images.edges.map(({node}) => {
                        return {
                            src: node.url
                        }
                    }),
                    description: node.descriptionHtml,
                    variants: node.variants.edges.map(({node}) => {
                        const {title, price, id, compareAtPrice, image} = node;
                        return {
                            title, price: price.amount,
                            original_price: compareAtPrice?.amount,
                            platform_variant_id: id,
                            image: image ? image.url : null,
                        }
                    }),
                    totalInventory: node.totalInventory,
                }
            }).filter(({availableForSale})=>availableForSale)
            return {
                cursor, products:p, hasNext
            }
        }).catch((e)=>{
            console.log(e)
            return {
                products:[]
            }
        })

    }
}

const applyDiscountToCheckout = (client, discountCode, checkoutId)=>{
    console.log('applying discount code')
    const query = `mutation checkoutDiscountCodeApplyV2($discountCode: String!, $checkoutId: ID!) {
          checkoutDiscountCodeApplyV2(
            discountCode: $discountCode
            checkoutId: $checkoutId
          ) {
            checkout {
              id
              webUrl
            }
            checkoutUserErrors {
              code
              field
              message
            }
         }
    }`
    return client.post('graphql.json', {
        query,
        variables: { discountCode, checkoutId }
    }).then(({ data }) => {
        console.log('result', data.data)
        return data.data.checkoutDiscountCodeApplyV2.checkout.webUrl
    }).catch((e)=>{
        console.log(e)
        return null;
    })
}

export const checkout = (note, tags)=>{
    return (dispatch, getState)=> {
        const coupon_codes = getState().settings.coupon_codes || []
        const referralCoupon = coupon_codes.filter((item)=>item.type === "referral")[0];
        const personalCoupon = coupon_codes.filter((item)=>item.type === "personal")[0];

        const client = getStorefrontClient(getState().settings)
        const query = `mutation checkoutCreate($input: CheckoutCreateInput!) {
              checkoutCreate(input: $input) {
                checkout {
                  id
                  webUrl
                  note
                }
                checkoutUserErrors {
                  code
                  field
                  message
                }
              }
        }`
        const customAttributes = [
            {
                key: 'Affiliate',
                value: getState().settings.email
            }
        ]
        const cartItems = getState().cartItems;
        const items = cartItems.map((item) => {
            const { variant, quantity } = item
            return { variantId: variant.platform_variant_id, quantity }
        })
        return client.post('graphql.json', {
            query,
            variables: { input: { note, tags, lineItems: items, customAttributes } }
        }).then(async ({ data }) => {
            try {
                if (referralCoupon || personalCoupon) {
                    const checkoutId = data.data.checkoutCreate.checkout.id;
                    const {code} = referralCoupon || personalCoupon;
                    await applyDiscountToCheckout(client, code, checkoutId)
                }
            }catch(e){
                console.log(e)
            }
            return data.data.checkoutCreate.checkout.webUrl
        }).catch((e)=>{
            return null;
        })
    }
}
